/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AppId } from "../../commons/types/AppId";
export const ConstraintCreate = core.serialization.object({
    description: core.serialization.string().optional(),
    function: core.serialization.string().optional(),
    options: core.serialization.any().optional(),
    label: core.serialization.string().optional(),
    validator: core.serialization.string().optional(),
    appId: AppId.optional(),
});
